import React, { useEffect } from 'react'
import { ArrowRight, ArrowUp, BookOpen, Check, ChevronLeft, ChevronRight, Circle, Clock, Facebook, Instagram, Linkedin, Menu, Tv, Twitter, X } from 'react-feather'
import aos from 'aos'


const Pricing = () => {
    useEffect(() => {
        aos.init({ duration: 2000 });
    }, [])
    return (
        <>
            {/* <!-- Start Pricing area --> */}
            <div id="pricing" className="rn-pricing-area pricing-style-2 rn-section-gap section-separator">
                <div className="container">
                    <div className="row">

                        <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100" data-aos-once="true" className="col-lg-4 col-sm-12">
                            <div className="title-area-wrapper mb_md--20 mb_sm--20">
                                <div className="section-title text-left">
                                    <span className="subtitle">Pricing</span>
                                    <h2 className="title">Our Pricing</h2>
                                </div>
                                <p className="title-disc">

                                    <ul>
                                        <li>
                                            100% satisfaction guaranteed

                                        </li>
                                        <li>
                                            Great communication
                                        </li>
                                        <li>
                                            Bring your idea to life

                                        </li>
                                        <li>
                                            Full Support after delivery

                                        </li>
                                        <li>
                                            Client satisfaction is my priority

                                        </li>
                                        <li>
                                            Services to help not to sell

                                        </li>
                                    </ul>
                                </p>
                                <p className="title-disc-2">
                                    Get the bundle and get lifetime support and one year updates.
                                </p>
                            </div>
                        </div>

                        <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay="300" data-aos-once="true" className="col-lg-4 col-md-6 col-sm-12">
                            <div className="pricing-wrapper">
                                <div className="ts-header">
                                    <h6>REACT Web App </h6>
                                </div>
                                <h3 className="price">$2000</h3>
                                <div className="pricing-body">
                                    <div className="feature">
                                        <Clock />
                                        <span className="name">15 Delivery days</span>
                                    </div>
                                    <div className="feature">
                                        <Check />
                                        <span className="name">35 pages</span>
                                    </div>
                                    <div className="feature">
                                        <Check />
                                        <span className="name off">Design Customization</span>
                                    </div>
                                    <div className="feature">
                                        <Check />
                                        <span className="name off">Content Upload</span>
                                    </div>
                                    <div className="feature">
                                        <Check />
                                        <span className="name off">Responsive Design</span>
                                    </div>

                                    <div className="feature">
                                        <Check />
                                        <span className="name off">Include Source Code</span>
                                    </div>
                                </div>
                                <div className="pricing-footer">
                                    <a className="rn-btn" href="#contacts"><span>BUY NOW</span></a>
                                </div>
                            </div>
                        </div>

                        <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay="500" data-aos-once="true" className="col-lg-4 col-md-6 col-sm-12">
                            <div className="pricing-wrapper-pro">
                                <div className="ts-header">
                                    <h6 style={{ fontFamily: "sans-serif", fontsize: "10px" }}>REACT NATIVE MOBILE APPLICATION</h6>
                                </div>
                                <h3 className="price">$2500</h3>
                                <div className="pricing-body">
                                    <div className="feature">
                                        <Clock />
                                        <span className="name">30 Delivery days</span>
                                    </div>
                                    <div className="feature">
                                        <Check />
                                        <span className="name">Functional App</span>
                                    </div>
                                    <div className="feature">
                                        <Check />
                                        <span className="name off">30 Screens</span>
                                    </div>
                                    <div className="feature">
                                        <Check />
                                        <span className="name off">App Icon</span>
                                    </div>
                                    <div className="feature">
                                        <Check />
                                        <span className="name off">Splash Screen</span>
                                    </div>

                                    <div className="feature">
                                        <Check />
                                        <span className="name off">Include Source Code</span>
                                    </div>
                                </div>
                                <div className="pricing-footer">
                                    <a className="rn-btn" href="#contacts"><span>BUY NOW</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- End Pricing Area --> */}

        </>
    )
}

export default Pricing